module.exports = __webpack_public_path__ + "img/icon_card2.8889e08b.png";